<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      labelWidth="120px"
    ></STable>

    <el-dialog
      v-dialogDrag
      title="分配成员"
      :visible.sync="dialogVisibleUser"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <el-input placeholder="输入关键字进行过滤" v-model="filterText1">
      </el-input>
      <el-tree
        :data="usertree"
        show-checkbox
        :props="defaultProps"
        :filter-node-method="filterNode1"
        node-key="id"
        :default-checked-keys="list"
        ref="usertree"
      >
      </el-tree>
      <div
        class="btns"
        style="margin-top:30px; display: flex; align-items: center; justify-content:center;"
      >
        <el-button @click="cancel" class="resetbtn">取消</el-button>
        <el-button type="success" @click="save">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      title="菜单权限"
      :visible.sync="dialogVisibleMenu"
      :close-on-click-modal="false"
      width="40%"
      center
    >
      <el-input placeholder="输入关键字进行过滤" v-model="filterText">
      </el-input>
      <el-tree
        :data="menutree"
        check-on-click-node
        check-strictly
        default-expand-all
        show-checkbox
        :props="defaultProps"
        :filter-node-method="filterNode"
        node-key="id"
        :default-checked-keys="list1"
        ref="menutree"
      >
      </el-tree>
      <div
        class="btns"
        style="margin-top:30px; display: flex; align-items: center; justify-content:center;"
      >
        <el-button @click="cancel1" class="resetbtn">取消</el-button>
        <el-button type="success" @click="saveMenus">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "jueseguanli",
  components: {},
  data() {
    return {
      url: "/auth/role/page",
      components: {},
      columns: [
        {
          label: "角色名称",
          prop: "name"
        },
        {
          label: "平台级数据授权",
          prop: "platformAuth",
          template: function(index, reocrd) {
            return reocrd.platformAuth ? "是" : "否";
          }
        },
        {
          label: "数据权限",
          prop: "authData"
        },
        {
          label: "创建人",
          prop: "creater"
        },
        {
          label: "创建时间",
          prop: "createDate"
        }
      ],
      handles: {
        width: 400,
        btns: [
          {
            label: "修改",
            permission: "role.manage.pageupdate",
            style: "color:#00CC00",
            handle: res => {
              this.$router.push({
                path: "./reviserole",
                query: { data: res.id }
              });
            }
          },
          {
            label: "分配成员",
            style: "color:#00CC00",
            permission: "role.manage.members",
            before: (index, record) => {
              this.id = record.id;
              this.usertree = [];
              this.list = [];
              let data = {
                id: record.id
              };
              //获取分配成员树
              this.$store.dispatch("form/handle", {
                url: "/auth/user/findUserAuthRes",
                method: "get",
                callback: resp => {
                  // this.usertree = resp
                  var usertreeData = resp;

                  this.$store.dispatch("form/handle", {
                    url: "/auth/role",
                    data: data,
                    method: "get",
                    callback: resp => {
                      for (let i = 0; i < resp.userList.length; i++) {
                        this.list.push(resp.userList[i]);
                      }
                      this.usertree = usertreeData;
                    }
                  });
                }
              });
              this.dialogVisibleUser = true;
            }
          },
          {
            label: "菜单权限",
            permission: "role.manage.menu",
            style: "color:red",
            before: (index, record) => {
              this.id = record.id;
              this.menutree = [];
              this.list1 = [];
              //获取菜单权限树
              let data = {
                bizType: "menu"
              };
              this.$store.dispatch("form/handle", {
                url: "/auth/findMy",
                data: data,
                method: "get",
                callback: resp => {
                  this.menutree = resp[1];
                  console.log(this.menutree);
                }
              });
              this.dialogVisibleMenu = true;
            },
            handle: resp => {
              let data = {
                id: resp.id
              };
              this.$store.dispatch("form/handle", {
                url: "/auth/role",
                data: data,
                method: "get",
                callback: resp => {
                  for (let i = 0; i < resp.authList.length; i++) {
                    if (
                      resp.authList[i].bizType == "menu"
                      // && resp.authList[i].bizKey.length == 5
                    ) {
                      this.list1.push(resp.authList[i].bizKey);
                    }
                  }
                }
              });
            }
          },
          {
            label: "删除",
            permission: "role.manage.ruledelete",
            style: "color:red",
            url: "/auth/role",
            method: "delete",
            isConfirm: true,
            before: (index, records) => {
              let arr = [];
              arr.push(records.id);
              return {
                ids: arr
              };
            },
            handle: () => {
              this.$refs.tableref.queryTable();
            }
          }
        ]
      },
      query: [
        {
          label: "角色名称",
          prop: "name",
          placeholder: "请输入角色名称"
        }
        // {
        //   label:"功能类型",
        //   prop:"type",
        //   type:"select",
        //   placeholder:"请选择功能类型",
        //   data:[
        //     {
        //       label:"平台",
        //       value:"0"
        //     },
        //     {
        //       label:"运营商",
        //       value:"1"
        //     },
        //     {
        //       label:"车辆机构",
        //       value:"2"
        //     }
        //   ]
        // }
      ],
      toolbar: [
        {
          label: "新增",
          permission: "role.manage.pageadd",
          type: "success",
          handle: resp => {
            this.$router.push("./addrole");
          }
        }
      ],
      dialogVisibleUser: false,
      dialogVisibleMenu: false,
      userIds: [],
      usertree: [],
      permissionIds: [],
      menutree: [],
      rowdata: {},
      id: "",
      filterText: "",
      filterText1: "",
      defaultProps: {
        children: "children",
        label: "name"
      },
      list: [],
      list1: []
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.userIds = [];
      this.dialogVisibleUser = false;
    },

    save() {
      this.userIds = [];
      const nodes = this.$refs.usertree.getCheckedNodes(true, false);
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (!node.noData) {
          this.userIds.push({
            id: node.id
          });
        }
      }

      let data = {
        id: this.id,
        userList: this.userIds
      };
      console.log(data);
      this.$store.dispatch("form/handle", {
        url: "/auth/role",
        data: data,
        method: "post",
        callback: resp => {
          this.dialogVisibleUser = false;
        }
      });
    },

    cancel1() {
      this.permissionIds = [];
      this.dialogVisibleMenu = false;
    },

    //保存菜单权限
    saveMenus() {
      this.permissionIds = [];
      const nodes = this.$refs.menutree.getCheckedNodes(false, true);
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (!node.noData) {
          this.permissionIds.push(node.id);
        }
      }
      let data = {
        roleId: this.id,
        data: {
          menu: this.permissionIds
        }
      };
      this.$store.dispatch("form/handle", {
        url: "/auth",
        data: data,
        method: "put",
        callback: resp => {
          this.dialogVisibleMenu = false;
        }
      });
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    filterNode1(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    }
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.menutree.filter(val);
    },
    filterText1(val) {
      this.$refs.usertree.filter(val);
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.SForm {
  margin-left: 150px;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00;
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color: #00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/userManagement/rolemanagement.vue